<template>
  <div class="chat-sidebar">
    <!-- Top Section: User Info and Online/Offline Toggle -->
    <div class="expert-section" v-if="loggedInUserType == 'Active RA' || loggedInUserType == 'Non Active RA'">
      <div class="user-info-header">
        <div class="user-details">
          <img :src="profile_pic" v-if="profile_pic" alt="User Avatar" class="user-avatar" />
          <div v-else alt="User Avatar" class="user-initial-avatar">{{ initialName(userProfile.full_name) }}</div>

          <div class="left-margin-10">
            <div class="user-name">{{ userProfile && userProfile.full_name }}</div>
            <div class="sebi-number" v-if="userProfile && userProfile.sebi_regi_number">SEBI No. {{ userProfile.sebi_regi_number }}</div>
          </div>
        </div>

        <el-switch v-model="isOnline" active-color="#079e3e" inactive-color="#ff4949" active-text="Online" inactive-text="Offline" :disabled="isToggleDisabled" @change="changeStatus()" />
      </div>
    </div>

    <div v-else>
      <div class="flex user-chat-hostory-section">
        <div>
          <i class="el-icon-back cursor-pointer" @click="backToExpertPage()"></i>
          Chat History
        </div>
      </div>
    </div>

    <div class="top-margin-10">
      <el-input v-model="search" placeholder="Search" class="search-input" prefix-icon="el-icon-search" clearable size="small" />
    </div>

    <!-- User Chat List -->
    <el-scrollbar class="user-list">
      <div v-if="filteredUsers.length">
        <div v-for="(user, index) in filteredUsers" :key="index" @click="selectUser(user)" class="user-card" :class="[{ 'selected-user': (selectedUser && selectedUser.second_user_details && selectedUser.second_user_details.id == user.second_user_details.id) || (selectedUserForChat && Object.keys(selectedUserForChat).length && selectedUserForChat.second_user_details.id == user.second_user_details.id) }]" style="border-bottom: 1px solid #eee">
          <div class="user-item">
            <div>
              <img :src="serverHostName + user.second_user_details.photo" alt="User Avatar" class="user-avatar" v-if="user.second_user_details.photo" />
              <div alt="User Avatar" class="user-initial-avatar" v-else>{{ initialName(user.second_user_details.full_name) }}</div>
            </div>

            <div class="user-info-outer">
              <div class="user-info">
                <div>
                  <div class="user-name">
                    {{ user.second_user_details.full_name }}
                    <img src="../assets/images/verify.svg" alt="" v-if="user.second_user_details.profession != 'Retail Investor'" width="15px" />
                  </div>

                  <div v-if="isUserTyping.user_id == user.second_user_details.id && isUserTyping.is_user_typing" class="chat-message ellipsis" style="color: #2488ff; font-weight: 500">typing...</div>

                  <div v-else-if="user.last_message.type == 'TEXT'" class="chat-message ellipsis">{{ user.last_message ? user.last_message.message : '' }}</div>

                  <div v-if="user.last_message.type == 'MEDIA'" class="chat-message ellipsis">Media</div>
                </div>

                <!-- <div v-if="user.status_str == 'Requested' && (loggedInUserType == 'Active RA' || loggedInUserType == 'Non Active RA')" style="font-size: 10px; font-weight: 500; color: #c73e1d;">
                  {{ user.status_str }}
                </div> -->

                <div class="text-right" v-if="user.last_message && user.last_message.message">
                  <div class="chat-time">{{ user.last_message ? user.last_message.created_at : '' | chatTime }}</div>

                  <a v-if="user.retail_user_transcript" :href="user.retail_user_transcript" target="_blank">
                    <img src="../assets/images/Download icon (2).svg" alt="download" class="top-margin-5" />
                  </a>
                </div>
              </div>

              <div class="chat-note-outer">
                <!-- <el-tooltip class="item" effect="dark" content="Your chat history will be stored till 40 days." placement="bottom"> -->
                <!-- <img src="../assets/images/Download icon (2).svg" alt="download" @click="sendDownloadEvent(user.id)"> -->
                <!-- </el-tooltip> -->
                <!-- <div class="chat-note"> Your chat history will be stored till 40 days.</div> -->
              </div>
            </div>
          </div>

          <div style="font-size: 10px; font-weight: 500; color: #c73e1d; text-align: right" :style="[user.status_str == 'Completed' ? { color: '#079e3e' } : { color: '#d60918' }]">
            {{ user.status_str }}
          </div>
        </div>
      </div>

      <!-- <div v-if="!search && !filteredUsers.length" class="text-center top-margin-10">
        <div>
          <el-skeleton :rows="Number(3)" v-for="(row, index) in 5" :key="index" style="padding: 0 10px 20px 10px; text-align: left;" />
        </div>
      </div> -->

      <div class="text-center margin-top-20" v-if="!filteredUsers.length">
        <el-empty :image-size="150"></el-empty>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { serverHostName } from '../networkConfig';
import { screenSize } from '../mixins/ScreenSize.js';
// import socket from '../mixins/WebSocket.js';
import { HelperNetworkCallBack } from '../mixins/Helper';
import moment from 'moment';
import { ChatTimer } from '../mixins/ChatTimer.js';

export default {
  props: {
    loggedInUserType: {
      type: String, // or the expected type of `loggedInUserType`
      required: true,
    },
  },

  mixins: [screenSize, HelperNetworkCallBack, ChatTimer],

  data() {
    return {
      search: '',
      isOnline: localStorage.getItem('expertChatStatus') === 'true' ? true : false,
      recentUsers: [],
      selectedUser: {},
      profile_pic: null,
      isLoading: false,
      serverHostName: serverHostName,
      moment: moment,
    };
  },

  filters: {
    chatTime(time) {
      if (time) {
        return moment(time).format('MMM D, YYYY, hh:mm A');
      }
    },
  },

  watch: {
    screenOuterSize(newValue, oldValue) {
      if (oldValue) {
        this.selectedUser = {};
      }
    },

    isOnline(newValue, oldValue) {
      localStorage.setItem('expertChatStatus', newValue);
    },

    getLastMessageObj(newValue, oldValue) {
      if (newValue) {
        for (let i = 0; i < this.getRecentUsers.length; i++) {
          if (this.getRecentUsers[i].title == newValue.room) {
            console.log('this.getRecentUsers[i]', this.getRecentUsers[i]);
            this.$set(this.getRecentUsers[i].last_message, 'message', newValue.message);
            this.$set(this.getRecentUsers[i].last_message, 'created_at', newValue.time);
            this.$set(this.getRecentUsers[i].last_message, 'type', newValue.type);
          }
        }

        this.$store.commit('commitRecentUsers', this.getRecentUsers);
      }
    },
  },

  mounted() {
    // if(localStorage.getItem('hasUserRoomJoinedRoom')){
    //   console.log('page reloaded and user has already joined room');
    //   localStorage.removeItem('hasUserRoomJoinedRoom')
    // }

    this.changeStatus(); //by default set status

    // socket.off('recent-chat'); // Remove previous listeners to prevent duplication

    // socket.emit('get_recent_chat', { user_id: this.userProfile.id }, (ack) => {
    //   // console.log('Acknowledgment:', ack);
    // });

    // socket.on('recent-chat', (data) => {
    //   // this.startTimer();
    //   // if (data.login_user_id == this.userProfile.id) {
    //     console.log('recent-chat', data);
    //     this.isLoading = true;

    //     this.recentUsers = [];

    //     if (data.data.length) {
    //       for (let i = 0; i < data.data.length; i++) {
    //         this.recentUsers.push(data.data[i]);
    //       }

    //       let filteredRequestedUser = this.recentUsers.find((e) => e.status_str === 'Requested');

    //       if (filteredRequestedUser) {
    //         this.$store.commit('commitRoomId', filteredRequestedUser.title);
    //         this.$store.commit('commitNewChatRequestObj', filteredRequestedUser);

    //         if(this.loggedInUserType == 'Active RA' || this.loggedInUserType == 'Non Active RA'){
    //           this.$store.commit('commitNewChatRequestDialogState', true);
    //         }

    //       } else {
    //         this.$store.commit('commitNewChatRequestObj', {});
    //         this.$store.commit('commitNewChatRequestDialogState', false);
    //       }

    //       if(this.roomId && Object.keys(this.selectedUser).length){
    //         this.selectedUser = this.recentUsers.find((e) => this.roomId == e.title);
    //       }

    //       let filteredOngoingUser = this.recentUsers.find((e) => e.status_str === 'Ongoing');
    //       console.log("filteredOngoingUser", filteredOngoingUser, this.selectedUser, this.roomId);

    //       // if (filteredOngoingUser) {

    //       //   this.$store.commit('commitSelectedUserForChatObj', filteredOngoingUser);

    //       //   this.storeUserChatSessionDetails(filteredOngoingUser);

    //       // } else{
    //       //   this.storeUserChatSessionDetails(this.selectedUser);
    //       // }

    //       if (filteredOngoingUser && !Object.keys(this.selectedUser).length) {
    //         console.log("onGoingUser but not selected from sidebar", filteredOngoingUser);

    //         if(!localStorage.getItem('hasUserRoomJoinedRoom')){
    //           console.log('user has not joined room');

    //           this.selectUser(filteredOngoingUser);
    //           localStorage.setItem('hasUserRoomJoinedRoom', true);
    //         }

    //       } else if(filteredOngoingUser && Object.keys(this.selectedUser).length){
    //         console.log("onGoingUser and selected from sidebar", filteredOngoingUser);
    //         this.$store.commit('commitSelectedUserForChatObj', filteredOngoingUser);

    //         this.storeUserChatSessionDetails(filteredOngoingUser);
    //         // }
    //       }else{
    //         console.log("no onGoingUser", this.selectedUser);
    //         this.storeUserChatSessionDetails(this.selectedUser);
    //       }

    //       if (filteredOngoingUser || Object.keys(this.selectedUser).length) {
    //         // this.$emit('setupChatSessionTimer');
    //         this.startTimer();
    //       }
    //     }

    //     this.isLoading = false;
    //   // }
    // });

    if (this.userProfile) {
      if (this.userProfile.picture) {
        this.profile_pic = this.serverHostName + this.userProfile.picture;
      }

      // if(this.userProfile.chat_info){
      //   this.isOnline = this.userProfile.chat_info.online_status == 'Online' ? true : false;
      // }
    }
  },

  methods: {
    selectUser(user) {
      // console.log("selectUser", user);
      // this.storeUserChatSessionDetails(user);

      // this.$store.commit('commitSelectedUserForChatObj', user);

      // this.$store.commit('commitRoomId', user.title);
      // localStorage.setItem('selectedUserForChat', JSON.stringify(user));

      this.selectedUser = user;

      // if(this.loggedInUserType == 'Active RA' || this.loggedInUserType == 'Non Active RA'){
      //   this.$emit("userSelected", user, user.status_str);
      // }else{
      //   this.$emit("userSelected", user);
      // }
      this.$emit('userSelected', user);
      // if user is already selected then restrcited to emit event again - to avoid unnecessary socket calls
      // if(this.selectedUser.id != user.second_user_details.id){
      //   this.selectedUser = user;
      //   // localStorage.setItem("selectedUserForChat", user.id);
      //   this.$emit("userSelected", user);
      // }
    },

    // storeUserChatSessionDetails(user) {
    //   if (user && user.retail_user_session != null) {
    //     this.$store.commit('commitRoomId', user.title);
    //     this.$store.commit('commitUserChatSessionDetails', user.retail_user_session);
    //     localStorage.setItem('userChatSession', JSON.stringify(user.retail_user_session));
    //   }
    // },

    sendDownloadEvent(userId) {
      this.$emit('sendDownloadEvent', userId);
    },

    backToExpertPage() {
      this.$router.push({ path: '/expert-list' });
    },

    changeStatus() {
      this.$emit('changeStatus', this.isOnline);
    },
  },

  computed: {
    filteredUsers() {
      let users = [];

      if (this.search.trim()) {
        users = this.getRecentUsers.filter((user) => user.second_user_details.full_name.toLowerCase().includes(this.search.toLowerCase()));
      } else {
        users = this.getRecentUsers;
      }

      return users;
    },

    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    isUserTyping() {
      return this.$store.state.typingEvent;
    },

    getLastMessageObj() {
      return this.$store.state.lastMessageObj;
    },

    roomId() {
      return this.$store.state.room_id;
    },

    isToggleDisabled() {
      let disabled = false;

      let isOnGoingstatus = this.getRecentUsers.find((e) => {
        return e.status_str == 'Ongoing';
      });

      disabled = isOnGoingstatus ? true : false;

      return disabled;
    },

    getRecentUsers() {
      return this.$store.state.recentUsers;
    },

    selectedUserForChat() {
      return this.$store.state.selectedUserForChat || {};
    },
  },
};
</script>

<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.chat-sidebar {
  width: 450px;
  background-color: #ffff;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;

  .user-chat-hostory-section {
    background-color: #2488ff;
    color: #ffff;
    font-weight: 600;
    font-size: 15px;
    padding: 15px 20px 20px;

    .el-icon-back {
      font-size: 25px;
      position: relative;
      top: 4px;
    }
  }

  .user-info-outer {
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .user-info {
    display: flex;
    justify-content: space-between;
    align-items: self-start;
    // width: calc(100% - 50px);
    width: 100%;
  }

  .chat-note-outer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .chat-note {
      color: #828282;
      font-size: 11px;
      font-weight: 500;
    }

    .el-icon-download {
      color: #2488ff;
      font-weight: 500;
      font-size: 20px;
    }
  }

  .user-details {
    display: flex;
    align-items: center;

    .user-name {
      font-weight: 600;
      font-size: 0.9rem;
    }

    .sebi-number {
      font-size: 10px;
      color: $text-muted;
      font-weight: 500;
    }
  }

  .live-btn {
    color: $theme-green-color;
    background-color: $theme-light-green-color;
    border: 1px solid $theme-light-green-color;
    border-radius: 5px;
  }

  .history-btn {
    color: $text-muted;
    background-color: $btn-background-gray;
    border: 1px solid $btn-background-gray;
    border-radius: 5px;
  }

  .user-info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: #edf5ff;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  .user-initial-avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background-color: #4caf50;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .action-buttons {
    padding: 10px;
    display: flex;
  }

  .search-input {
    padding: 0 10px;
    width: 350px;
    border-radius: 50px;
  }

  .user-list {
    flex-grow: 1;
    overflow-y: auto;
    margin-top: 10px;
  }

  .user-card {
    cursor: pointer;
    padding: 10px 25px 10px 10px;

    &:hover {
      background-color: #eaeaea;
    }
  }

  .user-item {
    display: flex;

    .user-info {
      .user-name {
        font-weight: 600;
        font-size: 0.8rem;
        display: flex;
        align-items: center;

        img {
          width: 15px;
          margin-left: 3px;
        }
      }

      .chat-message {
        font-size: 0.8rem;
        font-weight: 200;
        margin-top: 5px;
      }

      .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 220px;
      }

      .chat-time {
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 880px) {
  .chat-sidebar {
    height: calc(100vh - 125px);
    width: 100% !important;
    margin-top: 60px;
  }
}

@media screen and (max-width: 520px) {
  .chat-sidebar .user-details {
    // .sebi-number {
    //   font-size: 9px;
    // }

    // .user-name[data-v-7c141d74] {
    //   font-size: 0.8rem;

    // }
  }
}
</style>
<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.chat-sidebar {
  .search-input {
    .el-input__icon {
      padding: 0 10px;
      font-size: 16px;
    }

    .el-input__inner {
      border-radius: 20px;
      padding-left: 35px;
      background-color: #f5f4f4;
    }
  }

  .action-buttons {
    .el-button {
      font-size: 10px;
      font-weight: 600;
      padding-top: 10px;
    }
  }

  .el-switch__label * {
    font-size: 11px;
  }

  .el-switch__core {
    width: 40px;
    height: 25px;
    border-radius: 20px;
  }

  .el-switch__core:after {
    height: 20px;
    width: 20px;
  }

  .el-switch.is-checked .el-switch__core::after {
    left: 100%;
    margin-left: -22px;
  }

  .el-switch__label {
    color: $text-muted;
  }

  .el-switch__label--left.is-active {
    color: #ff4949;
  }

  .el-switch__label--right.is-active {
    color: $theme-green-color;
  }

  .el-switch__label--left {
    font-weight: 600;
  }

  .el-switch__label--right {
    font-weight: 600;
  }

  .selected-user {
    background-color: #eaeaea;
  }
}
</style>